import React from "react";
import { Switch, Redirect, Route, useRouteMatch } from "react-router-dom";
import Disposition from "./Disposition/Main";
import Dialer from "../Dialer";
import ManageNumbers from "./ManageNumbers/Main";
import Voicemail from "./Voicemail";
import PowerDialer from "./PowerDialer";
import CallLogs from "./CallLogs";
import Utils from "Utils/utils";

const Routing = () => {
  let { path = "" } = useRouteMatch();
  const isAdmin = Utils.isAdmin();
  return (
    <Switch>
      <Route exact path={`${path}/general`} component={Dialer} />
      <Route exact path={`${path}/callDisposition`} component={Disposition} />
      {isAdmin && <Route exact path={`${path}/manageNumbers`} component={ManageNumbers} />}
      <Route exact path={`${path}/voicemail`} component={Voicemail} />
      <Route exact path={`${path}/powerDialer`} component={PowerDialer} />
      {isAdmin && <Route exact path={`${path}/callLogs`} component={CallLogs} />}
      <Redirect from={path} to={`${path}/general`} />
    </Switch>
  );
};
export default Routing;
